import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LeadActivitiesState {
  selectedTabId: string;
  currentPage: number;
  search: string;
  selectedTaskTypes: string[];
  selectedTaskStatuses: string[];
  dateRangeType: string;
  dateRangeFrom: string;
  dateRangeTo: string;
}

const initialState: LeadActivitiesState = {
  selectedTabId: 'tasks',
  currentPage: 0,
  search: '',
  selectedTaskTypes: [],
  selectedTaskStatuses: [],
  dateRangeType: 'today',
  dateRangeFrom: '',
  dateRangeTo: ''
};

export const leadActivitiesSlice = createSlice({
  name: 'leadActivities',
  initialState,
  reducers: {
    setActivitiesTab: (state, action: PayloadAction<string>) => {
      state.selectedTabId = action.payload;
    },
    setActivitiesPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setActivitiesSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
    setActivitiesTaskTypes: (state, action: PayloadAction<string[]>) => {
      state.selectedTaskTypes = action.payload;
    },
    setActivitiesTaskStatuses: (state, action: PayloadAction<string[]>) => {
      state.selectedTaskStatuses = action.payload;
    },
    setActivitiesDateRangeType: (state, action: PayloadAction<string>) => {
      state.dateRangeType = action.payload;
    },
    setActivitiesDateRange: (
      state,
      action: PayloadAction<{ from: string; to: string }>
    ) => {
      state.dateRangeFrom = action.payload.from;
      state.dateRangeTo = action.payload.to;
    },
    resetActivitiesState: () => initialState
  }
});

export const {
  setActivitiesTab,
  setActivitiesPage,
  setActivitiesSearch,
  setActivitiesTaskTypes,
  setActivitiesTaskStatuses,
  setActivitiesDateRangeType,
  setActivitiesDateRange,
  resetActivitiesState
} = leadActivitiesSlice.actions;

export default leadActivitiesSlice.reducer;
